/**
 * @author: Michal Mlčoch <xmlcoc12@stud.fit.vutbr.cz>
 */

import {useEffect, useState} from "react";
import {
    DataGrid,
    getGridSingleSelectOperators,
    getGridStringOperators,
    GridToolbarFilterButton
} from "@mui/x-data-grid";
import { Button, Box, Alert } from '@mui/material';
import Snackbar from '@mui/material/Snackbar';
import { getFrom } from '../../data/api';
import { makeStyles } from '@mui/styles';
import { useNavigate } from "react-router-dom";

const useStyles = makeStyles({
    root: {
        '& .UNCONFIRMED': {
            backgroundColor: '#ff9182',
        },
        '& .CONFIRMED': {
            backgroundColor: '#c3ff82',
        },
        '& .CLOSED': {
            backgroundColor: '#04bf42',
        },
    },
});

function MyAuctions () {
    const classes = useStyles();
    let navigate = useNavigate();

    const statusList = {
        "UNCONFIRMED": 'Nepotvrzená',
        "CONFIRMED": 'Potvrzená',
        "CLOSED": 'Ukončená',
    }

    const cols = [
        {field: 'title', headerName: "Nadpis", minWidth: 300, editable: false, sortable: false },
        {field: 'endAt', headerName: "Končí v", minWidth: 200, editable: false, sortable: false,
            valueGetter: ({ value }) => value && (new Date(value)).toLocaleString("cs-CZ")},
        {field: 'status', headerName: "Status", minWidth: 150, editable: false, sortable: false,
            renderCell: ( params ) => {return statusList[params.value]}},
        {field: 'createdBy', headerName: "Vytvořil", minWidth: 150, editable: false, sortable: false,
            valueGetter: ({ value }) => value && value.name},
        {field: 'createdAt', headerName: "Vytvořena", minWidth: 200, type: 'dateTime', sortable: false, 
            valueGetter: ({ value }) => value && (new Date(value)).toLocaleString("cs-CZ")},
        {field: "id", headerName: "", minWidth: 150, editable: false, sortable: false,
        renderCell: (params) => {
            return <Button 
            variant="contained"
            onClick={() => navigate(`/auctions/${params.row.id}`)}
            >Zobrazit</Button>
        }},
    ]

    const [data, setData] = useState([]);
    const [open, setOpen] = useState(false);
    const [msgInfo, setMsgInfo] = useState("");

    useEffect(()=>{
        getFrom('/auctions/my').then((res)=>{
            setData(res.data);
            if (res.status !== 200){
                setMsgInfo({severity: "error", msg:"Nepodařilo se načíst aukce!"});
                setOpen(true);
            }
        }).catch((e)=>{
            setMsgInfo({severity: "error", msg:"Nepodařilo se načíst aukce!"});
            setOpen(true);
        })
    },[])

    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }
        setOpen(false);
    };


    return (
        <Box
            sx={{mr: "5%", ml: "5%"}}
            >

            <Snackbar 
                open={open} 
                autoHideDuration={5000} 
                onClose={handleClose}>
                <Alert onClose={handleClose} severity={msgInfo.severity} sx={{ width: '100%' }}>
                    {msgInfo.msg}
                </Alert>
            </Snackbar>

            <DataGrid
                rows={data}
                columns={cols}
                pagination
                pageSize={20}
                paginationMode={"client"}
                disableSelectionOnClick
                className={classes.root}
                getCellClassName={(params) => {
                    if (params.field !== 'status')
                        return '';
                    
                    return params.value;
                }}
                />
        </Box>
    )
}

export default MyAuctions;